export default {
    tableClass: 'table',
    loadingClass: 'loading',
    ascendingIcon: 'fas fa-sort-amount-up',
    descendingIcon: 'fas fa-sort-amount-down',
    handleIcon: 'glyphicon glyphicon-menu-hamburger',
    pagination: {
        infoClass: 'pull-right',
        wrapperClass: 'button-group pull-right',
        activeClass: 'button variant-default',
        disabledClass: 'disabled',
        pageClass: 'button variant-neutral',
        linkClass: 'button variant-neutral',
        icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
        },
    },
}
